module.exports = __webpack_public_path__ + "img/lupa.af04edb4.png";